import { forwardRef } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import {
  type TDialogDescriptionElement,
  type TDialogDescriptionProps,
} from "@/ui/components/overlay/Dialog/Dialog.config";
import { TextBody } from "../../typography/TextBody";
import { cn } from "@/ui/lib";

export const DialogDescription = forwardRef<TDialogDescriptionElement, TDialogDescriptionProps>(
  (
    {
      children,
      ...props
    },
    ref,
  ) => (
    <DialogPrimitive.Description
      data-component="DialogDescription"
      ref={ref}
      className={cn(
        "text-foreground-muted-strong",
      )}
      {...props}
    >
      <TextBody
        tag="span"
        size={2}
        isResponsive={false}
        color="inherit"
        className="block"
      >
        { children }
      </TextBody>
    </DialogPrimitive.Description>
  ),
);

DialogDescription.displayName = DialogPrimitive.Description.displayName;
